import { extendTheme } from "@chakra-ui/react";

import { globalStyles } from "./styles";

import { fonts } from "./foundations/fonts";
import { breakpoints } from "./foundations/breakpoints";

import { Link } from "./components/link";
import { Avatar } from "./components/avatar";
import { Alert } from "./components/alert";
import {
  Input,
  Textarea,
  NumberInput,
  FormLabel,
  FormHelperText,
  Radio,
  Checkbox,
  FormErrorMessage,
} from "./components/form";
import { Text, Heading } from "./components/typography";
import { ProgressFilledTrack } from "./components/progress";

export default extendTheme({
  colors: globalStyles.colors,
  fonts,
  breakpoints,
  components: {
    Avatar,
    Alert,
    Link,
    FormLabel,
    FormHelperText,
    FormErrorMessage,
    Input,
    NumberInput,
    Textarea,
    Radio,
    Checkbox,
    ProgressFilledTrack,
    Text,
    Heading,
  },
});
